import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardLayoutUI = ({
  'data-selenium-id': dataSeleniumId,
  columnStart,
  Badge,
  Title,
  Subheading,
  Pricing,
  Seats,
  Term,
  Credits,
  Subtext,
  CTAs,
  Features,
  Footer
}) => {
  const layoutProps = {
    gridColumnStart: columnStart,
    gridColumn: `${columnStart} / span 1`
  };
  const styleProps = {
    paddingInline: '600',
    // visual borders are handled by the MerchCardColumns component for mobile and desktop
    // For desktop, we only need to show left border to show line between each column
    borderColor: 'border-core-subtle',
    borderWidth: '100',
    borderBlockStartStyle: undefined,
    // top border
    borderBlockEndStyle: undefined,
    // bottom border
    borderInlineEndStyle: undefined,
    // right border
    borderInlineStartStyle: columnStart > 1 ? 'solid' : undefined // left border
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Badge",
      position: "relative"
    }, layoutProps, {
      children: Badge
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Title",
      paddingBlockStart: "800",
      position: "relative",
      "data-selenium-id": dataSeleniumId
    }, layoutProps, styleProps, {
      children: Title
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subheading",
      paddingBlockStart: "200"
    }, layoutProps, styleProps, {
      children: Subheading
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Pricing",
      paddingBlockStart: "400"
    }, layoutProps, styleProps, {
      children: Pricing
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Seats",
      paddingBlockStart: Seats ? '400' : '0'
    }, layoutProps, styleProps, {
      children: Seats
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Term",
      paddingBlockStart: Term ? '400' : '0'
    }, layoutProps, styleProps, {
      children: Term
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "CTAs",
      paddingBlockStart: "600"
    }, layoutProps, styleProps, {
      children: CTAs
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Credits",
      paddingBlockStart: Credits ? '600' : '0'
    }, layoutProps, styleProps, {
      children: Credits
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subtext"
    }, layoutProps, styleProps, {
      children: Subtext
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Features",
      paddingBlockStart: "600"
    }, layoutProps, styleProps, {
      children: Features
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Footer",
      paddingBlockStart: "400",
      paddingBlockEnd: "600"
    }, layoutProps, styleProps, {
      children: Footer
    }))]
  });
};